import React from 'react'
import { useMutationWithValidation } from 'src/editor/api/hooks/use-api-mutation-with-validation'
import { websitePagesQuery } from 'src/editor/api/queries/website-pages-query'
import { unpublishWebsitePage } from 'src/editor/api/website-pages-api'
import { WarningDialogWindow } from 'src/editor/shared/ui-lib/modal-window/dialog-window/warning-dialog-window'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

export interface UnpublishPageModalProps {
  websiteId: number
  websitePageSetId: number
  websitePageId: number
  isOpened: boolean
  onClose: () => void
}

export const UnpublishPageModal = ({
  websiteId,
  websitePageSetId,
  websitePageId,
  isOpened,
  onClose,
}: UnpublishPageModalProps) => {
  const { t } = useTypedTranslation()

  const { fetcher, isLoading } = useMutationWithValidation({
    requestFunction: unpublishWebsitePage,
    successToastMessage: t(
      'website_settings.sidebar.pages_management.unpublish_page.unpublished_successfully',
    ),
    handleFinally: onClose,
    setQueryDataArgsOnSuccess: websitePagesQuery.setQueryDataArgs(
      [websiteId],
      prevData => ({
        ...prevData,
        pages: prevData.pages.map(websitePageSet =>
          websitePageSet.id === websitePageSetId
            ? {
                ...websitePageSet,
                locales: websitePageSet.locales.map(websitePage =>
                  websitePage.id === websitePageId
                    ? { ...websitePage, active: false }
                    : websitePage,
                ),
              }
            : websitePageSet,
        ),
      }),
    ),
  })

  const handleUnpublishPage = () => {
    if (websitePageId) {
      fetcher({ websitePageId })
    }
  }

  return (
    <WarningDialogWindow
      isOpened={isOpened}
      onClose={onClose}
      title={t(
        'website_settings.sidebar.pages_management.unpublish_page.title',
      )}
      description={t(
        'website_settings.sidebar.pages_management.unpublish_page.description',
      )}
      cancelButtonProps={{
        children: t('global.cancel'),
        onClick: onClose,
      }}
      confirmButtonProps={{
        isLoading,
        onClick: handleUnpublishPage,
        children: t(
          'website_settings.sidebar.pages_management.unpublish_page.unpublish_button',
        ),
      }}
    />
  )
}
